const NAME = 'recipient_name'

const NAME_COLUMN_WIDTH = 333

const VARIABLE = 'recipient_variable'

const VARIABLE_COLUMN_WIDTH = 333

export const QA_NAME_VARIABLES_MODAL = 'variables'

export const REPORT_PAGE_SIZE = 10

export const REPORT_COLUMNS = {
  [NAME]: {
    index: 0,
    key: 0,
    name: NAME,
    title: 'Emails.VariablesReportRecipientColumnNameKey',
    visible: true,
    width: NAME_COLUMN_WIDTH,
  },
  [VARIABLE]: {
    index: 1,
    key: 1,
    name: VARIABLE,
    title: 'Emails.VariablesReportVariableColumnNameKey',
    visible: true,
    width: VARIABLE_COLUMN_WIDTH,
  },
}
